







































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import { getLocalStorage } from '../../../store/src/utils/index'
import verifyCode from './VerifyCode.vue'
@Component({
	components: {
		verifyCode
	}
})
export default class VerifyCodes extends Vue {
	@Prop ({
		type: String,
		required: true,
		default: ''
	}) private flag!: string
	@Prop ({
		type: String,
		required: true,
		default: ''
	}) private title!: string
	@Prop ({
		type: Boolean,
		required: false,
		default: false
	}) private inputDisabled!: boolean
	@Prop ({
		type: Boolean,
		required: false,
		default: true
	}) private state!: boolean
	@Prop ({
		type: String,
		required: false,
		default: ''
	}) private name!: string
	@Prop() private beforeClick!: any
	private names: string = ''
	private code: string = ''
	private type: number = 1
	private verifyImgCode: string = ''
	private uuid: string = (this as any).$fxUtils.createUUID()
	private verifyCodeImgUrl: string = ''
	private created () {
		this.initData()
	}
	private initData () {
		if (this.flag === 'mobile') {
			this.initMobile()
		} else if (this.flag === 'email') {
			this.initEmail()
		}
	}
	private initMobile () {
		if (this.name) {
			this.names = this.name.substr(0, 3) + '******' + this.name.substr(-3, 3)
			this.type = 7
		}	else {
			this.type = 6
		}
	}
	private initEmail () {
		if (this.name && this.name !== 'null') {
			const arr = this.name.split('@')
			this.names = arr[0].substr(0, 3) + '***' + arr[0].substr(-3, 3) + '@' + arr[1]
			this.type = 5
		} else {
			this.type = 4
		}
	}
	private beforeVerifyCodeClick () {
		if (this.flag === 'mobile') {
			return new Promise ((resolve: any) => {
				this.validateVerifyImgCode(this.verifyImgCode).then(() => {
					if (this.state) {
						this.$emit('on-vaildate-mobile', this.name, resolve)
					} else {
						this.$emit('on-vaildate-mobile', this.names, resolve)
					}
				})
			})
		} else if (this.flag === 'email') {
			return new Promise ((resolve: any) => {
				this.validateVerifyImgCode(this.verifyImgCode).then(() => {
					if (this.state) {
						this.$emit('on-vaildate-email', this.name, resolve)
					} else {
						this.$emit('on-vaildate-email', this.names, resolve)
					}
				})
			})
		}
	}
	private validateVerifyImgCode (value: any) {
		return new Promise ((resolve: any) => {
			if (!value) {
				(this as any).$fxMessage.error('图形验证码不能为空')
				return false
			} else {
				resolve()
			}
		})
	}
	@Watch('uuid', { immediate: true })
	private onUuidChange (val: any, oldVal: any) {
		this.verifyCodeImgUrl = `/cldEdi/business/${val}/getVerifyCode`
	}
	private refreshVerifyImgCode () {
		this.uuid = (this as any).$fxUtils.createUUID()
		const verifyImgCode = (this as any).$refs.verifyImgCode
		verifyImgCode.select()
	}
	private onConfirmClick () {
		if (this.flag === 'mobile') {
			this.beforeMobileHandle()
		} else if (this.flag === 'email') {
			this.beforeEmailHandle()
		}
	}
	private vaildateCode (value: any) {
		return new Promise ((resolve: any) => {
			if (!value) {
				(this as any).$fxMessage.error('验证码不能为空')
				return false
			} else if (!(this as any).$fxUtils.regVerifyCode().test(value)) {
				(this as any).$fxMessage.error('验证码为四位数字')
				return false
			} else {
				resolve()
			}
		})
	}
	private beforeMobileHandle () {
		this.vaildateCode(this.code).then(() => {
			if (this.state) {
				this.$emit('on-unbind-mobile', this.name, this.code)
			} else {
				this.$emit('on-bind-mobile', this.names, this.code)
			}
		})
	}
	private beforeEmailHandle () {
		this.vaildateCode(this.code).then(() => {
			if (this.state) {
				this.$emit('on-unbind-email', this.name, this.code)
			} else {
				this.$emit('on-bind-email', this.names, this.code)
			}
		})
	}
	private destoryCode (type, name, state) {
		if (type === 'mobile' && state) {
			this.type = 6
		} else if (type === 'mobile' && !state) {
			this.type = 7
		} else if (type === 'email' && state) {
			this.type = 4
		} else if (type === 'email' && !state) {
			this.type = 5
		}
		this.names = name
		this.code = ''
	}
}
